const theme = {
  '--color-primary': 'rgba(0, 0, 0, 0.87)',
  '--color-primary-active': '#05e8ba',
  '--color-primary-hover': '#172A3A',
  '--color-secondary': '#FFFFFF',
  '--color-background': '#F4F4F4',
  '--color-surface': '#FFFFFF',
  '--color-error': '#D15582',
  '--font-family': 'Montserrat, sans-serif, "Open Sans"'
};

export default theme;
